import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ComponentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      components: [],
      loading: true
    };
    this.insertUser = this.insertUser.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .get(`${URL.api}configuration/link/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState(
            () => ({
              components: resp.data.data
            }),
            () => {
              this.setState(() => ({
                loading: false
              }));
            }
          );
        },
        error => {
          this.props.logout(this.props.user.token);
        }
      );
  }

  insertUser() {
    this.props.history.push("/component/create");
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {this.state.components ? (
              <div id="list">
                <DataTable
                  list={this.state.components}
                  path="/component/edit/"
                  title="Componentes"
                  header={[
                    { name: "id", denomination: "id" },
                    { name: "name", denomination: "name" },
                    { name: "path", denomination: "path" },
                    { name: "url", denomination: "url" },
                    { name: "component", denomination: "component" },
                    { name: "exact", denomination: "exact" },
                    { name: "local", denomination: "local" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertUser}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ComponentList);
